export default {
    STORY_RECEIVED: 'STORY_RECEIVED',
    STORY_REMOVED: 'STORY_REMOVED',
    STORY_RENAMED: 'STORY_RENAMED',
    STORY_DESCRIPTION_CHANGED: 'STORY_DESCRIPTION_CHANGED',
    STORY_CREATING_POSTS: 'STORY_CREATING_POSTS',
    STORY_PROJECTS_UPDATED: 'STORY_PROJECTS_UPDATED',
    STORY_PUBLISHING: 'STORY_PUBLISHING',
    STORY_PUBLISHED: 'STORY_PUBLISHED',
    STORY_UNPUBLISHING: 'STORY_UNPUBLISHING',
    STORY_UNPUBLISHED: 'STORY_UNPUBLISHED',
};
